import { useEffect, useState } from "react";

// Row selection for bulk Approve All / Reject All on a DataTable.
// Selection only applies to the rows currently shown, so it is dropped
// whenever the table data changes (page, search, filter, refetch).
//
// Spread `tableProps` into <DataTable> when bulk actions are allowed.
export const useBulkSelection = (data) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleClearRows, setToggleClearRows] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    setSelectedRows([]);
    setToggleClearRows((t) => !t);
  }, [data]);

  return {
    selectedRows,
    isProcessing,
    setIsProcessing,
    tableProps: {
      selectableRows: true,
      onSelectedRowsChange: ({ selectedRows }) => setSelectedRows(selectedRows),
      clearSelectedRows: toggleClearRows,
    },
  };
};
